import { useEffect, useRef } from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useAnalysisStore } from '../../store/useAnalysisStore';
import Url from '../../data/url';
import { ANALYSIS_STATUS } from '../../data/define';
import IcProgress from '../../assets/image/ic_analysis_inprogress.svg';
import IcSuccess from '../../assets/image/ic_analysis_success.svg';
import IcError from '../../assets/image/ic_analysis_fail.svg';
import { useTranslation } from '../../hook/useTranslation';

function AnalysisStatusFloatingBar() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { status } = useAnalysisStore((s) => s.analysisResult);
  const aiJobId = useAnalysisStore((s) => s.aiJobId);
  const savedJobIdRef = useRef<string | null>(null);

  // SUCCESS 후 결과 페이지에서 jobId를 저장해두어 다른 페이지에서도 복원 가능하게
  useEffect(() => {
    if (location.pathname === Url.KidsAnalysisResult) {
      const jobIdParam = searchParams.get('jobId');
      if (jobIdParam) {
        savedJobIdRef.current = jobIdParam;
      }
    }
  }, [location.pathname, searchParams]);

  if (status === ANALYSIS_STATUS.STANDBY) {
    return null;
  }

  const navigateToResult = () => {
    // SUCCESS 상태: jobId로 복원 가능하도록 URL에 포함
    if (status === ANALYSIS_STATUS.SUCCESS) {
      const jobId = aiJobId || savedJobIdRef.current;
      navigate(jobId ? `${Url.KidsAnalysisResult}?jobId=${jobId}` : Url.KidsAnalysisResult, {
        replace: true,
      });
      return;
    }
    // PENDING / ERROR / NOTHING: store의 aiJobId로 폴링 재개 가능, 파라미터 불필요
    navigate(Url.KidsAnalysisResult, { replace: true });
  };

  return (
    <div
      className="fixed z-[9999] bottom-15 right-5"
      style={{ display: location.pathname === Url.KidsAnalysisResult ? 'none' : 'block' }}
    >
      <div className="flex items-center justify-center h-[48px] rounded-[10px] bg-white shadow-lg cursor-pointer">
        {status === ANALYSIS_STATUS.PENDING && (
          <button
            type="button"
            onClick={navigateToResult}
            className="w-full h-full rounded-[10px] flex items-center justify-between px-3 text-[#fff] font-[700] bg-[#5EBEBB]"
          >
            <span className="text-[#fff]">{t('analysis.status.pending')}</span>
            <img src={IcProgress} alt="Analysis in progress" className="ml-2" />
          </button>
        )}
        {status === ANALYSIS_STATUS.SUCCESS && (
          <button
            type="button"
            onClick={navigateToResult}
            className="w-full h-full rounded-[10px] flex items-center justify-between px-3 text-[#fff] font-[700] bg-[#5EBEBB]"
          >
            <span className="text-[#fff]">{t('analysis.status.success')}</span>
            <img src={IcSuccess} alt="Analysis success" className="ml-2" />
          </button>
        )}
        {(status === ANALYSIS_STATUS.ERROR || status === ANALYSIS_STATUS.NOTHING) && (
          <button
            type="button"
            onClick={navigateToResult}
            className="w-full h-full rounded-[10px] flex items-center justify-between px-3 text-[#fff] font-[700] bg-[#969696]"
          >
            <span className="text-[#fff]">{t('analysis.status.error')}</span>
            <img src={IcError} alt="Analysis error" className="ml-2" />
          </button>
        )}
      </div>
    </div>
  );
}

export default AnalysisStatusFloatingBar;
